import { render, staticRenderFns } from "./OrganizCategory.vue?vue&type=template&id=59576795&scoped=true&"
import script from "./OrganizCategory.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizCategory.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizCategory.vue?vue&type=style&index=0&id=59576795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59576795",
  null
  
)

export default component.exports